import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TClip, TPatchClip } from '../types';

export async function patchClip(body: TPatchClip): Promise<TClip> {
  const { time_keeping_note, ...rest } = body;
  const payload = emptyStringValues(rest);
  if (time_keeping_note !== undefined) {
    payload.time_keeping_note = time_keeping_note;
  }
  return mediaManagerClient.patch(`/api/v1/clips/${body.id}`, payload);
}

type MutationFn = typeof patchClip;

type TUsePatchClipParams = {
  config?: MutationConfig<MutationFn>;
  invalidateClipQueries?: boolean;
};

export function usePatchClip({
  config = {},
  invalidateClipQueries = false,
}: TUsePatchClipParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: ({ silently = false, ...body }: TPatchClip) => patchClip({ ...body, silently }),
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar el corte'));
      console.error(error);
    },
    onSuccess(data, variables, context) {
      if (!variables.silently) {
        addSuccessNotification(t('El corte se ha actualizado correctamente'));
        if (invalidateClipQueries) {
          queryClient.invalidateQueries({ queryKey: ['clips'] });
        }
        config.onSuccess?.(data, variables, context);
      }
    },
  });
}
